// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".voiceover-preview--Na6PV{width:100%;height:100%;background-color:#5645f5}.playback--dhrO9{position:absolute;bottom:1rem;left:50%;transform:translateX(-50%);width:min(480px,90%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"voiceover-preview": "voiceover-preview--Na6PV",
	"playback": "playback--dhrO9"
};
export default ___CSS_LOADER_EXPORT___;
